<template>
  <section class="customer-detail-placeholder">
    <article class="customer-detail-card">
      <header class="customer-detail-card-header">
        <h4>{{ title }}</h4>
      </header>
      <p>
        {{ message }}
      </p>
    </article>
  </section>
</template>

<script>
export default {
  name: 'CustomerDetailPlaceholderTab',
  props: {
    title: {
      type: String,
      default: 'Sección',
    },
    message: {
      type: String,
      default: 'Esta sección estará disponible en la siguiente iteración.',
    },
  },
};
</script>
